module.exports = __webpack_public_path__ + "d72d78c130d984e77a23afe86ae8fe77.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/mini-snowman-s.png
// module id = 2684
// module chunks = 0